module.exports = require("./su-Latn");